module.exports = __webpack_public_path__ + "static/media/Weather.00cf2af8.svg";